<template>
	<div id="users">
		<h1><i class="fad fa-users fa-fw"></i> Users</h1>
		<div v-if="isLoading"><i class="fad fa-spinner-third fa-spin fa-2x"></i></div>
		<div v-else id="user-container" class="rec-container">
			<router-link v-bind:to="'/admin/user/edit/' + user.id" class="rec" v-for="user in userList" v-bind:key="user.id">
				<div>
					<span>{{user.nameFirst}} {{user.nameLast}}</span> 
					<span class="info">({{user.role}})</span>
					<span class="group">{{user.group}}</span>
				</div>
			</router-link>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			isLoading: false
		};
	},
	computed: {
		userList(){
			return this.$store.getters.usersAlpha
		}
	},
	methods: {
		async loadUsers() {
			this.isLoading = true
			await this.$store.dispatch('loadUsers')
			setTimeout(()=>{ 
				this.isLoading = false
			},150)
		}
	},
	created() {
		if( this.userList.length <= 1){
			this.loadUsers()
		}
	}
}

</script>
<style scoped>
:root {
	--ar-purple: #483751;
}

.rec {
	position: relative;
}

	.group {
		background-color: var(--ar-purple);
		color: #fff;
		display: block;
		padding: 3px;
		position: absolute;
		text-align: center;
		text-transform: uppercase;
		right: 0;
		top: 0;
	}

	.rec > div span:last-child {
		padding-right: 3px;
	}
</style>